import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/Website/Hero.css';

function Hero({ onOpenModal }) {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      title: "HijaAsset YOUR TRADE 6",
      subtitle: "A new episode every fortnight: tune into uncut conversations with the people transforming the world's biggest industries.",
      cta: "Trade Now"
    }
  ];

  const stats = [
    { value: "0.0", label: "PIP SPREADS*" },
    { value: "1:1000", label: "LEVERAGE" },
    { value: "0.01", label: "MICRO LOT TRADING" },
    { value: "+2250", label: "TRADABLE INSTRUMENTS" },
    { value: "24/7", label: "DEDICATED SUPPORT" }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleTradeNow = () => {
    navigate('/register');
  };

  return (
    <section className="hero" id="home">
      <div className="hero-slider">
        <div className="hero-slide" style={{ backgroundImage: 'linear-gradient(135deg, #0a1628 0%, #1a3a52 100%)' }}>
          <div className="hero-content-wrapper">
            <div className="hero-content">
              <div className="hero-text">
                <h1 className="hero-title">
                  <span className="ic-green">HijaAsset</span> Trade<br />
                  Smarter.<span className="ic-green"></span>
                </h1>
                <p className="hero-subtitle">
                Institutional-grade trading tools built for serious traders.
                Powering Every Move You Make in the Market.
                Precision execution. Advanced charts. Zero compromise.
                </p>
                <button className="btn-watch-now" onClick={handleTradeNow}>Trade Now</button>
              </div>
              
              <div className="hero-image">
                <div className="profile-images">
                  <div className="profile-left">
                    <img src="/home1.png" alt="Profile 1" />
                  </div>
                  <div className="profile-right">
                    <img src="/home2.png" alt="Profile 2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Stats Bar */}
          <div className="stats-bar">
            {stats.map((stat, index) => (
              <div className="stat-item" key={index}>
                <div className="stat-value">{stat.value}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Chat Widget */}
      <div className="chat-widget">
        <div className="chat-bubble">Hi!</div>
        <div className="chat-prompt">How can I help you?</div>
        <button className="chat-button">💬</button>
      </div>
    </section>
  );
}

export default Hero;